'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EmptyStateStyled = require('./EmptyStateStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// React-Wrapper-Pflichtmuster (wie Card.jsx/Alert.jsx): reicht `className` durch,
// damit Konsumenten via styled(EmptyState) ihr Layout ergaenzen koennen. Kapselt den
// zentrierten Leer-Zustand-Block. `icon` ist optional (Emoji-String oder beliebiger
// Node); `title` ist die Kernaussage, `description` der erklaerende Untertext.
// `title`/`description` werden nur gerendert, wenn gesetzt (kein leerer Knoten).
var EmptyState = function EmptyState(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['className', 'icon', 'title', 'description', 'children']);

  return _react2.default.createElement(
    _EmptyStateStyled.EmptyStateBox,
    _extends({ className: className }, rest),
    icon != null && _react2.default.createElement(
      _EmptyStateStyled.EmptyStateIcon,
      null,
      icon
    ),
    title != null && _react2.default.createElement(
      _EmptyStateStyled.EmptyStateTitle,
      null,
      title
    ),
    description != null && _react2.default.createElement(
      _EmptyStateStyled.EmptyStateDescription,
      null,
      description
    ),
    children
  );
};

EmptyState.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.node,
  title: _propTypes2.default.node,
  description: _propTypes2.default.node,
  children: _propTypes2.default.node
} : {};

EmptyState.defaultProps = {
  className: undefined,
  icon: null,
  title: null,
  description: null,
  children: null
};

exports.default = EmptyState;
module.exports = exports['default'];